import React from 'react';
import Footer from '../tools/Footer'
import BarHorizontale from '../tools/BarHorizontale'
import TotalUsers from '../tools/dashbord/TotalUsers'
import UsersConnected from '../tools/dashbord/UsersConnected'
import TauxConversion from '../tools/dashbord/TauxConversion'
import Conversations from '../tools/dashbord/Conversations'
import ConteneurActif from '../tools/dashbord/ConteneurActif'
import KiloActif from '../tools/dashbord/KiloActif'
import ConteneurAttente from '../tools/dashbord/ConteneurAttente'
import ConteneurRejet from '../tools/dashbord/ConteneurRejet'
import DiagramConteneurDispo from '../tools/dashbord/DiagramConteneurDispo'
import DiagramRepartionPartage from '../tools/dashbord/DiagramRepartionPartage'
import DiagramKiloDispo from '../tools/dashbord/DiagramKiloDispo'
import ControleTotal from '../tools/dashbord/ControleTotal'
import ScroolTop from '../tools/ScroolTop'

function Dashbord({users, announcements, announcements2, announcements3}) {
  return (
    <>
        <div className="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <BarHorizontale />
                <div className="container-fluid">
                    <div className="d-sm-flex justify-content-between align-items-center mb-4">
                        <h3 className="text-dark mb-0">Dashboard</h3>
                        {/* <a className="btn btn-primary btn-sm d-none d-sm-inline-block" role="button" href="#">
                            <i className="fas fa-download fa-sm text-white-50"></i>&nbsp;Generer un Rapport
                        </a> */}
                    </div>
                    <div className="row">
                        <TotalUsers nbuser={users.length}/>
                        <UsersConnected users={users}/>
                        <TauxConversion />
                        <Conversations />
                    </div>
                    <div className="row">
                        <ConteneurActif nbConteneurFalse={announcements2?announcements2.length:0} nbConteneur={announcements['container']?announcements['container'].length:0}/>
                        <KiloActif nbKiloFalse={announcements3?announcements3.length:0} nbKilo={announcements['kilos']?announcements['kilos'].length:0}/>
                        <ConteneurAttente nbConteneurFalse={announcements2?announcements2.length:0}/>
                        <ConteneurRejet 
                            conteneurFalse={announcements2?announcements2:null}
                            kiloFalse={announcements3?announcements3:null}
                        />
                    </div>
                    <div className="row">
                        <DiagramConteneurDispo conteneur={announcements['container']?announcements['container']:[]}/>
                        <DiagramRepartionPartage nbuser={users.length} kilo={announcements['kilos']?announcements['kilos']:[]} conteneur={announcements['container']?announcements['container']:[]}/>
                    </div>
                    <div className="row">
                        <DiagramKiloDispo kilo={announcements['kilos']?announcements['kilos']:[]}/>
                        <ControleTotal />
                    </div>
                    {/* <div className="row">
                    </div> */}
                </div>
            </div>
            <Footer/>
        </div>
        <ScroolTop />
    </>
  )
}

export default Dashbord